<!-- Bid Room -->
<template>
  <div class="br-list-page" v-bind="$attrs">
    <div class="header-section">
      <h3>청약공고</h3>
    </div>

    <!-- 입찰 공고 리스트 -->
    <div class="announcement-box">
      <div class="announcement-header">
        <div>위탁 매장 운영 사업주 모집 공고</div>
        <div v-if="userInfo && userInfo.OGN_FG === '00' && ['younghee9580','TB관리자'].includes(this.userInfo.userId)">
          <button @click="toggleConfirmList" class="btn-add">확정자 리스트</button>
          <button @click="toggleConfirmed" class="btn-add">{{ showConfirmed ? '전체리스트' : '미확정리스트'}}</button>
          <button @click="openPopup" class="btn-add">공고 등록</button>
        </div>
      </div>
      <div 
        class="announcement-body"
        :style="userInfo && userInfo.OGN_FG === '00' && ['younghee9580','TB관리자'].includes(this.userInfo.userId)
          ? { maxHeight: '240px' } 
          : { maxHeight: '120px' }"
        >
        <table v-if="!showConfirmList" class="announcement-body-table">
          <thead>
            <tr>
              <th v-if="userInfo && userInfo.OGN_FG === '00' && ['TB관리자'].includes(this.userInfo.userId)">공고번호</th>
              <th>공고명</th>
              <th>FC</th>
              <th>매장명</th>
              <th>공고일</th>
              <th>청약 마감일</th>
              <th v-if="userInfo && userInfo.OGN_FG === '00'">등록자수</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in bidRooms" :key="index" @dblclick="openAnnouncementEdit(item)" class="announcement-row" >
              <td v-if="userInfo && userInfo.OGN_FG === '00' && ['TB관리자'].includes(this.userInfo.userId)">{{ item.BID_ID }}</td>
              <td>
                <strong>{{ item.BID_NM }}</strong>
              </td>
              <td>{{ item.BRANCH_NM }}</td>
              <td>{{ item.SHOP_NM }}</td>
              <td>
                {{ new Date(item.INS_DT).toISOString().slice(0, 10) }}
              </td>
              <td>
                <strong>
                  {{ item.DEADLINE.slice(0, 10) }} / {{ item.DEADLINE.slice(11, 16) }}
                </strong>
              </td>
              <td v-if="userInfo && userInfo.OGN_FG === '00'">
                <!-- {{ applyListData.filter(item => item.APPLY_ID).length }}명 -->
                {{ item.APPLY_CNT }}명
              </td>
              <td>
                <button
                v-if="( userInfo && userInfo.OGN_FG === '01' && !this.isDeadlinePassed(item.DEADLINE) ) || (['TB관리자'].includes(this.userInfo.userId))"
                @click="selectAnnouncement(item)"
                class="btn-select"
                >
                  청약하기
                </button>

                <button
                  v-if="userInfo && userInfo.OGN_FG === '00' && 
                    (['younghee9580'].includes(this.userInfo.userId) ||
                     ['김종배', '육상용',].includes(this.userInfo.EMP_NM) ||
                     ['관리자팀'].includes(this.userInfo.EMP_DEPT_NM) ||
                     (['본부장'].includes(this.userInfo.EMP_CLASS_NM) && this.userInfo.EMP_DEPT_NM === '판매본부')
                    )"
                  @click="applyList(item)"
                  class="btn-select"
                >
                  청약리스트
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 확정자 리스트 -->
        <table v-else class="announcement-body-table">
          <thead>
            <tr>
                <th>공고명</th>
                <th>매장명</th>
                <th>청약지원자</th>
                <th>도전자 나이</th>
                <th>근무매장</th>
                <th>전화번호</th>
                <th>마감일</th>
                <th>확정자</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(confirm, index) in confirmList" :key="index">
              <td>{{ confirm.BID_NM }}</td>
              <td>{{ confirm.SHOP_NM }}</td>
              <td>{{ confirm.CANDIDATE_NM }}</td>
              <td>{{ confirm.CANDIDATE_AGE }}</td>
              <td>{{ confirm.CURRENT_SHOP }}</td>
              <td>{{ confirm.PHONE_NO }}</td>
              <td>{{ confirm.DEADLINE.slice(0, 10) }} / {{ confirm.DEADLINE.slice(11, 16) }}</td>
              <td>{{ confirm.CONFIRMED_NM }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 선택된 공고 상세 및 신청 폼 -->
    <div class="bid-form-container" v-if="selectedAnnouncement">
      <!-- <div class="form-title">입찰 신청서 작성</div> -->
      <div class="form-content">
        <!-- 왼쪽 표-->
        <div class="form-left">
          <div class="form-title">{{ bidShop }} 판매수량 현황</div>
          <ag-grid-vue
            class="ag-br-balham"
            :theme="theme"
            :rowData="rowData2"
            :columnDefs="columnDefs2"
            :gridOptions="gridOptions2"
            @grid-ready="onLeftGridReady"
            :rowHeight="rowHeight"
            :enableCellSpan="true"
            style="width: 100%; height: 665px"
          ></ag-grid-vue>
        </div>
        <!-- 오른쪽 신청서 -->
        <div class="form-right">
          <div class="form-title">청약 신청서 작성</div>
          <table class="bid-form-table">
            <tbody>
              <tr>
                <th>공고명</th>
                <td colspan="3">
                  {{ bidNm }}
                </td>
              </tr>
              <tr>
                <th>청약매장</th>
                <td colspan="3">
                  {{ bidShop }}
                </td>
              </tr>
              <tr>
                <th>본부명</th>
                <td colspan="3">{{ bidBranch }} 본부</td>
              </tr>
              <!-- <tr>
                <th>추천 사업주</th>
                <td colspan="3">
                  <input type="text" v-model="ownerNm" />
                </td>
              </tr> -->
              <tr>
                <th>도전자 이름</th>
                <td>
                  <input
                    type="text"
                    v-model="userNm"
                    placeholder="이름 입력"
                    maxlength="20"
                  />
                </td>
                <th>나이</th>
                <td>
                  <input
                    type="number"
                    v-model="userAge"
                    placeholder="나이 입력"
                  />
                </td>
              </tr>
              <tr>
                <th>근무매장</th>
                <td>
                  <input type="text" v-model="currentShop" />
                </td>
                <th>핸드폰 번호</th>
                <td>
                  <input
                    type="text"
                    v-model="phoneNo"
                    placeholder="01012345678"
                    maxlength="11"
                    @input="phoneNo = phoneNo.replace(/[^0-9]/g, '')"
                  />
                </td>
              </tr>
              <tr>
                <th colspan="4">사업주 본인 간단한 소개</th>
              </tr>
              <tr>
                <td colspan="4">
                  <textarea
                    v-model="bidEtc"
                    maxlength="500"
                    placeholder="자기소개 입력"
                    rows="8"
                    style="width: 100%"
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="form-footer">
            <div class="notice-box">
              사업주가 되면 사업소득을 무한대로 벌수 있습니다.<br />
              돈을 많이 벌고 싶다면, 사업주 방 청약에 도전하세요.
            </div>
            <button @click="submitBid" class="btn-submit">청약 신청하기</button>
            <button @click="closeForm" class="btn-close">닫기</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 선택된 공고 상세 입찰 리스트 -->
    <div class="bid-form-container" v-if="showApplyList">
      <div class="list-form-content">
        <!-- 왼쪽: 신청서 -->
        <div class="form-left-details">
          <!-- <div class="form-title notice-box">{{ bidShop }} 사업주 청약 등록현황 <br>총 등록자는 {{ applyListData.filter(item => item.APPLY_ID).length }}명</div> -->
          <table class="list-form-table">
            <thead>
              <tr style="background-color: #fac276; font-weight: bold">
                <td></td>
                <td></td>
                <td>청약 지원자</td>
                <!-- <td>추천 사업주</td> -->
                <td>도전자 나이</td>
                <td>근무매장</td>
                <td>전화번호</td>
                <td>자기소개</td>
                <td>상태</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(apply, index) in applyListData"
                :key="apply.APPLY_ID"
                @click="handleRowClick(apply.APPLY_ID)"
              >
                <td>
                  <input type="checkbox" v-model="apply.checked" @click.stop />
                </td>
                <td>{{ index + 1 }}</td>
                <td>{{ apply.CANDIDATE_NM }}</td>
                <!-- <td>{{ apply.OWNER_NM }}</td> -->
                <td>{{ apply.CANDIDATE_AGE }}</td>
                <td>{{ apply.CURRENT_SHOP }}</td>
                <td>{{ apply.PHONE_NO }}</td>
                <td class="etc-cell">{{ apply.ETC }}</td>
                <td>{{ apply.CONFIRMED_ID ? "확정" : "" }}</td>
              </tr>
            </tbody>
          </table>
          <div class="form-footer">
            <button 
              v-if="userInfo && userInfo.OGN_FG === '00' && 
                    (['younghee9580'].includes(this.userInfo.userId) ||
                     ['관리자팀'].includes(this.userInfo.EMP_DEPT_NM)
                    )"
              @click="saveConfirm" 
              class="btn-submit">
              확정
            </button>
            <button @click="closeForm" class="btn-close">닫기</button>
          </div>
        </div>
        <!-- 오른쪽: 상세 같은페이지-->
        <div class="form-right-details" v-if="showRightDetails">
          <!-- <img src="/kkk.png" alt="매장 이미지" class="announcement-image" /> -->
          <div class="bid-dt-container">
            <div class="">
              <div class="bt-title">
                {{ bidShop }} &nbsp;청 약 &nbsp;&nbsp;신 청 서 &nbsp;&nbsp;작 성
              </div>
              <div style="display: flex; justify-content: space-between"></div>
              <div class="notice-text">
                사업주 도전을 응원합니다.<br />
                타이어 뱅크(주)의 사업주 모집은 자율경쟁 입찰 방식으로
                진행됩니다.<br />
                참여를 희망하시는 분께서는 아래 양식에 따라 제안 판매 수량 및
                금액을 기재하여 청약해 주시기 바랍니다.<br />
                입찰자는 제안 수량과 금액이 높은 순으로 우선 선정되며, 세부 심사
                기준에 따라 최종 결정됩니다.<br />
                신중하게 검토하신 후 제안해 주시기 바랍니다.
              </div>
              <div>
                <!-- 반복문으로 1~3지망 생성 -->
                <div
                  v-for="pref in [1, 2, 3]"
                  :key="pref"
                  class="proposal-section"
                >
                  <h3>{{ pref }}지망 청약 신청서</h3>

                  <!-- 1지망: 점번/점명 직접 세팅 -->
                  <div v-if="pref === 1" class="store-info">
                    <label
                      >점번:
                      <input
                        type="text"
                        v-model="proposalInfo[1].storeNo"
                        readonly
                    /></label>
                    <label
                      >점명:
                      <input
                        type="text"
                        v-model="proposalInfo[1].storeNm"
                        readonly
                    /></label>
                  </div>

                  <!-- 2,3지망: 매장 선택 -->
                  <div v-else class="store-info">
                    <!-- 점번 / 점명 입력 -->
                    <div class="store-info">
                      <label
                        >점번:
                        <input
                          type="text"
                          v-model="proposalInfo[pref].storeNo"
                          readonly
                      /></label>
                      <label
                        >점명:
                        <input
                          type="text"
                          v-model="proposalInfo[pref].storeNm"
                          readonly
                      /></label>
                    </div>
                  </div>
                  <div>
                    ①판매 약정금액
                    <input
                      type="text"
                      v-model="proposalInfo[pref].planAmt"
                      @input="formatAmount(pref, $event)"
                      readonly />(원)
                    판매 약정금액 제안
                    <input
                      type="text"
                      v-model="proposalInfo[pref].agreedAmt"
                      @input="formatAmount(pref, $event)"
                      readonly />(원)
                  </div>
                  <div>②판매 약정수량 제안</div>
                  <!-- 월별 테이블 -->
                  <table class="bid-dt-table" style="font-size: 0.8rem;">
                    <thead>
                      <tr>
                        <th style="width: 12%">구분</th>
                        <th v-for="m in 12" :key="m">{{ m }}월</th>
                        <th>합계</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- 최고 판매수량 -->
                      <tr>
                        <th>기존 최고수량</th>
                        <td v-for="m in 12" :key="'max' + m">
                          <input
                            type="text"
                            :value="
                              (pref === 1
                                ? detailMaxQtyByMonth
                                : pref === 2
                                ? detailMaxQtyByMonth2
                                : detailMaxQtyByMonth3)[m + 'month'] ?? ''
                            "
                            :style="{fontSize: '0.8rem'}"
                            readonly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            :value="
                              (pref === 1
                                ? detailMaxQtyByMonth
                                : pref === 2
                                ? detailMaxQtyByMonth2
                                : detailMaxQtyByMonth3
                              ).totalCnt ?? ''
                            "
                            :style="{fontSize: '0.8rem'}"
                            readonly
                          />
                        </td>
                      </tr>

                      <!-- 제안 수량 -->
                      <tr>
                        <th>{{ pref }}지망 제안수량</th>
                        <td v-for="m in 12" :key="'qty' + pref + m">
                          <input type="text" v-model="proposalQty[pref][m]" style="font-size: 0.8rem;" readonly />
                        </td>
                        <td>
                          <input type="text" :value="sumQty(pref)" style="font-size: 0.8rem;" readonly />
                        </td>
                      </tr>

                      <!-- 차이 -->
                      <tr>
                        <th>최고수량과 차이</th>
                        <!-- 월별 차이 -->
                        <td v-for="m in 12" :key="'diff' + pref + m">
                          <input
                            type="text"
                            :value="
                              Number(proposalQty[pref][m] || 0) -
                              Number(
                                (pref === 1
                                  ? detailMaxQtyByMonth
                                  : pref === 2
                                  ? detailMaxQtyByMonth2
                                  : detailMaxQtyByMonth3)[m + 'month'] || 0,
                              )
                            "
                            readonly
                            :style="{
                              color: (() => {
                                const diff =
                                  Number(proposalQty[pref][m] || 0) -
                                  Number(
                                    (pref === 1
                                      ? detailMaxQtyByMonth
                                      : pref === 2
                                      ? detailMaxQtyByMonth2
                                      : detailMaxQtyByMonth3)[m + 'month'] || 0,
                                  );
                                if (diff === 0) return 'black';
                                return diff < 0 ? 'blue' : 'red';
                              })(),
                              fontSize: '0.8rem',
                            }"
                          />
                        </td>

                        <!-- 합계 차이 -->
                        <td>
                          <input
                            type="text"
                            :value="
                              sumQty(pref) -
                              Number(
                                (pref === 1
                                  ? detailMaxQtyByMonth
                                  : pref === 2
                                  ? detailMaxQtyByMonth2
                                  : detailMaxQtyByMonth3
                                ).totalCnt || 0,
                              )
                            "
                            readonly
                            :style="{
                              color: (() => {
                                const diff =
                                  sumQty(pref) -
                                  Number(
                                    (pref === 1
                                      ? detailMaxQtyByMonth
                                      : pref === 2
                                      ? detailMaxQtyByMonth2
                                      : detailMaxQtyByMonth3
                                    ).totalCnt || 0,
                                  );
                                if (diff === 0) return 'black';
                                return diff < 0 ? 'blue' : 'red';
                              })(),
                              fontSize: '0.8rem',
                            }"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                style="
                  margin-top: 10px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                "
              >
                <label style="margin: 0">청약 일자 :</label>
                {{ proposalDate }}
              </div>

              <div
                style="
                  margin-top: 10px;
                  display: flex;
                  justify-content: center;
                  gap: 5px;
                "
              >
                <label>청약자명 : </label>
                <span style="margin-left: 4px">{{ userNm }}</span>
              </div>
              <div
                style="margin-top: 10px; display: flex; justify-content: center"
              >
                <label style="margin-left: 10px">연락처 : </label>
                <span style="margin-left: 4px">{{ phoneNo }}</span>
              </div>
              <div
                style="
                  margin-top: 10px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span style="align-self: center">서 명:</span>
                <div v-if="signatureDataUrl">
                  <img
                    :src="signatureDataUrl"
                    alt="signature preview"
                    style="border: 1px solid #ccc; width: 300px; height: 100px"
                  />
                </div>
                <div
                  v-else
                  style="
                    border: 1px dashed #ccc;
                    width: 300px;
                    height: 100px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #999;
                  "
                >
                  서명 없음( X )
                </div>
              </div>
              <div
                style="margin-top: 10px; display: flex; justify-content: center"
              >
                타 이 어 뱅 크 (주) &nbsp;&nbsp;귀 중
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 입찰등록 상세 페이지 -->
    <div class="bid-dt-container" v-if="detailWrite">
      <!-- <div class="form-title">입찰 신청서 작성</div> -->
      <div class="">
        <div class="bt-title">
          {{ bidShop }} &nbsp;청 약 &nbsp;&nbsp;신 청 서 &nbsp;&nbsp;작 성
        </div>
        <div style="display: flex; justify-content: space-between"></div>
        <div class="notice-text">
          사업주 도전을 응원합니다.<br />
          타이어 뱅크(주)의 사업주 모집은 자율경쟁 입찰 방식으로 진행됩니다.<br />
          참여를 희망하시는 분께서는 아래 양식에 따라 제안 판매 수량 및 금액을
          기재하여 청약해 주시기 바랍니다.<br />
          입찰자는 제안 수량과 금액이 높은 순으로 우선 선정되며, 세부 심사
          기준에 따라 최종 결정됩니다.<br />
          신중하게 검토하신 후 제안해 주시기 바랍니다.
        </div>
        
        <div>
          <!-- 반복문으로 1~3지망 생성 -->
          <div v-for="pref in [1, 2, 3]" :key="pref" class="proposal-section">
            <h3>{{ pref }}지망 청약 신청서</h3>

            <!-- 1지망: 점번/점명 직접 세팅 -->
            <div v-if="pref === 1" class="store-info">
              <label
                >점번:
                <input type="text" v-model="proposalInfo[1].storeNo" readonly
              /></label>
              <label
                >점명:
                <input type="text" v-model="proposalInfo[1].storeNm" readonly
              /></label>
            </div>

            <!-- 2,3지망: 매장 선택 -->
            <div v-else class="store-info">
              <div class="info-label">매장검색</div>
              <input
                list="team-datalist"
                v-model="proposalInfo[pref].teamSearch"
                @change="handleTeamSelection(pref)"
                class="team-select"
                placeholder="매장 검색 또는 선택"
                style="width: 200px"
              />
              <datalist id="team-datalist">
                <option
                  v-for="team in teamList"
                  :key="team.SHOP_CD"
                  :value="`(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`"
                />
              </datalist>
              <!-- 점번 / 점명 입력 -->
              <div class="store-info">
                <label
                  >점번:
                  <input
                    type="text"
                    v-model="proposalInfo[pref].storeNo"
                    readonly
                /></label>
                <label
                  >점명:
                  <input
                    type="text"
                    v-model="proposalInfo[pref].storeNm"
                    readonly
                /></label>
              </div>
            </div>
            <div>
              ①판매 약정금액
              <input
                type="text"
                v-model="proposalInfo[pref].planAmt"
                @input="formatAmount(pref, $event)"
                readonly 
              />(원)
              판매 약정금액 제안
              <input
                type="text"
                v-model="proposalInfo[pref].agreedAmt"
                @input="formatAmount(pref, $event)"
              />(원)
            </div>
            <div>②판매 약정수량 제안</div>
            <!-- 월별 테이블 -->
            <table class="bid-dt-table">
              <thead>
                <tr>
                  <th style="width: 12%">구분</th>
                  <th v-for="m in 12" :key="m">{{ m }}월</th>
                  <th>합계</th>
                </tr>
              </thead>
              <tbody>
                <!-- 최고 판매수량 -->
                <tr>
                  <th>기존최고 판매수량</th>
                  <td v-for="m in 12" :key="'max' + m">
                    <input
                      type="text"
                      :value="
                        (pref === 1
                          ? detailMaxQtyByMonth
                          : pref === 2
                          ? detailMaxQtyByMonth2
                          : detailMaxQtyByMonth3)[m + 'month'] ?? ''
                      "
                      readonly
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      :value="
                        (pref === 1
                          ? detailMaxQtyByMonth
                          : pref === 2
                          ? detailMaxQtyByMonth2
                          : detailMaxQtyByMonth3
                        ).totalCnt ?? ''
                      "
                      readonly
                    />
                  </td>
                </tr>

                <!-- 제안 수량 -->
                <tr>
                  <th>{{ pref }}지망 제안 수량</th>
                  <td v-for="m in 12" :key="'qty' + pref + m">
                    <input 
                      type="text" 
                      v-model="proposalQty[pref][m]"
                      @input="proposalQty[pref][m] = proposalQty[pref][m].replace(/[^0-9]/g, '')"
                    />
                  </td>
                  <td><input type="text" :value="sumQty(pref)" readonly /></td>
                </tr>

                <!-- 차이 -->
                <tr>
                  <th>최고 수량과 차이</th>
                  <!-- 월별 차이 -->
                  <td v-for="m in 12" :key="'diff' + pref + m">
                    <input
                      type="text"
                      :value="
                        Number(proposalQty[pref][m] || 0) -
                        Number(
                          (pref === 1
                            ? detailMaxQtyByMonth
                            : pref === 2
                            ? detailMaxQtyByMonth2
                            : detailMaxQtyByMonth3)[m + 'month'] || 0,
                        )
                      "
                      readonly
                      :style="{
                        color: (() => {
                          const diff =
                            Number(proposalQty[pref][m] || 0) -
                            Number(
                              (pref === 1
                                ? detailMaxQtyByMonth
                                : pref === 2
                                ? detailMaxQtyByMonth2
                                : detailMaxQtyByMonth3)[m + 'month'] || 0,
                            );
                          if (diff === 0) return 'black';
                          return diff < 0 ? 'blue' : 'red';
                        })(),
                      }"
                    />
                  </td>

                  <!-- 합계 차이 -->
                  <td>
                    <input
                      type="text"
                      :value="
                        sumQty(pref) -
                        Number(
                          (pref === 1
                            ? detailMaxQtyByMonth
                            : pref === 2
                            ? detailMaxQtyByMonth2
                            : detailMaxQtyByMonth3
                          ).totalCnt || 0,
                        )
                      "
                      readonly
                      :style="{
                        color: (() => {
                          const diff =
                            sumQty(pref) -
                            Number(
                              (pref === 1
                                ? detailMaxQtyByMonth
                                : pref === 2
                                ? detailMaxQtyByMonth2
                                : detailMaxQtyByMonth3
                              ).totalCnt || 0,
                            );
                          if (diff === 0) return 'black';
                          return diff < 0 ? 'blue' : 'red';
                        })(),
                      }"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <div>
          <br>
          {{ currentYearVal }}년 &nbsp;판매 &nbsp;약정 &nbsp;기준 &nbsp;금액 : 
          <input type="text" v-model="dpAmtCurrentYear" @input="formatAmount('current', $event)" placeholder="금액 입력" />
        </div>
        <div>
          {{ nextYearVal }}년 &nbsp;판매 &nbsp;기준 &nbsp;약정 &nbsp;금액 &nbsp;증액 제안 : 
          <input type="text" v-model="dpAmtNextYear"  @input="formatAmount('next', $event)" placeholder="금액 입력" />
        </div> -->
        <div
          style="
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          "
        >
          <label style="margin: 0">청약 일자 :</label>
          <input
            type="date"
            v-model="proposalDate"
            :max="today"
            style="height: 28px"
          />
        </div>

        <div style="margin-top: 10px; display: flex; justify-content: center">
          <label>청약 &nbsp;제안자명 : </label>
          <input type="text" v-model="userNm" style="text-align: center" />
          <div>
            &nbsp;청약자 &nbsp;핸드폰: <input type="text" v-model="phoneNo" maxlength="11" @input="phoneNo = phoneNo.replace(/[^0-9]/g, '')"/>
          </div>
        </div>
        <div
          style="
            margin-top: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <span style="align-self: center">서 명:</span>
          <div
            v-if="!signatureDataUrl"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 4px;
            "
          >
            <VueSignaturePad
              ref="signaturePad"
              :options="{ backgroundColor: 'white', penColor: 'black' }"
              style="border: 1px solid #ccc; width: 300px; height: 100px"
            />
            <button @click="clearSignature" style="width: 300px">지우기</button>
          </div>

          <div
            v-else
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 4px;
            "
          >
            <img
              :src="signatureDataUrl"
              alt="signature preview"
              style="border: 1px solid #ccc; width: 300px; height: 100px"
            />
            <button @click="editSignature" style="width: 300px">
              다시 작성
            </button>
          </div>
        </div>
        <div style="margin-top: 10px; display: flex; justify-content: center">
          타 이 어 뱅 크 (주) &nbsp;&nbsp;귀 중
        </div>
        <div class="form-footer">
          <br /><br />
          <button @click="saveProposal" class="btn-submit">청약 신청</button>
          <button @click="closeDetail" class="btn-close">닫기</button>
        </div>
      </div>
    </div>
  </div>

  <!-- 공고등록 팝업 -->
  <div v-if="showPopup" class="popup-overlay">
    <div class="popup-container">
      <h3>{{ editMode ? "공고 수정" : "공고 등록" }}</h3>
      <table class="popup-table">
        <tbody>
          <tr>
            <th>공고명</th>
            <td><input type="text" v-model="newAnnouncement.bidNm" /></td>
          </tr>
          <tr>
            <th>본부</th>
            <td>
              <select v-model="selectedBranch" class="branch-select" :disabled="editMode">
                <option
                  v-for="branch in branchList"
                  :key="branch.BRANCH_CD"
                  :value="branch.BRANCH_CD"
                >
                  {{ branch.BRANCH_NM }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>매장명</th>
            <td>
              <input
                list="team-datalist"
                v-model="teamSearch"
                @change="handleTeamChange"
                class="team-select"
                placeholder="매장 검색 또는 선택"
                :disabled="userInfo && userInfo.OGN_FG === '01'|| editMode"
              />

              <datalist id="team-datalist">
                <option
                  v-for="team in teamList"
                  :key="team.SHOP_CD"
                  :value="`(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`"
                />
              </datalist>
            </td>
          </tr>
          <tr>
            <th>마감일시</th>
            <td>
              <input type="datetime-local" v-model="newAnnouncement.deadline" />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="popup-footer">
        <button @click="saveAnnouncement" class="btn-submit">{{ editMode ? "수정" : "저장" }}</button>
        <button @click="closePopup" class="btn-close">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { themeBalham } from "ag-grid-community";
import VueSignaturePad from "vue3-signature-pad";

export default {
  name: "BrListPage",
  components: {
    AgGridVue,
    VueSignaturePad,
  },
  data() {
    return {
      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#c0c0c0",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      today: (() => {
        const d = new Date();
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      })(),

      userInfo: null,
      showPopup: false,
      newAnnouncement: {
        bidNm: "",
        shopNm: "",
        deadline: "",
        imageFile: null,
      },
      bidRooms: [],
      selectedAnnouncement: null, //왼 - 판매수량, 오 - 청약신청서 작성화면
      bidId: "",
      bidNm: "",
      bidShop: "",
      bidBizNo: "",
      bidShopCd: "",
      bidBranch: "",
      detailMaxQtyByMonth: {},
      detailMaxQtyByMonth2: {},
      detailMaxQtyByMonth3: {},
      ownerNm: "",
      userNm: "",
      userAge: "",
      currentShop: "",
      phoneNo: "",
      bidEtc: "",
      selectedImageUrl: "",
      showApplyList: false, //왼 - 신청리스트, 오 - 청약신청서 상세화면
      applyListData: [],
      detailWrite: false,
      signatureDataUrl: null,
      proposalDate: "",
      amtCurrentYear: null, // 실제 숫자 값
      amtNextYear: null, // 실제 숫자 값
      dpAmtCurrentYear: "", // 화면 표시용 (콤마 포함)
      dpAmtNextYear: "", // 화면 표시용 (콤마 포함)
      showRightDetails: false, //오 - 청약신청서 상세화면

      applyId: null,
      currentYearVal: new Date().getFullYear(),
      nextYearVal: new Date().getFullYear() + 1,
      proposerName: "",
      // proposalQty: {
      //   [new Date().getFullYear()]: {},
      //   [new Date().getFullYear() + 1]: {},
      // },
      proposalInfo: {
        1: { storeNo: "", storeNm: "", storeCd: "", agreedAmt: "", planAmt: "" },
        2: { storeNo: "", storeNm: "", storeCd: "", agreedAmt: "", planAmt: "" },
        3: { storeNo: "", storeNm: "", storeCd: "", agreedAmt: "", planAmt: "" },
      },
      proposalQty: {
        1: {}, // 1지망 월별 제안
        2: {}, // 2지망 월별 제안
        3: {}, // 3지망 월별 제안
      },

      selectedBranch: "", // 선택된 본부
      branchList: [],
      teamList: [], // 팀 목록
      selectedTeam: "", // 선택된 팀
      teamSearch: "", // 매장

      showConfirmList: false,
      showConfirmed: false,
      confirmList: [],

      editMode: false,
      editingBidId: null,

      rowData2: [],
      columnDefs2: [
        {
          headerName: "",
          field: "year",
          valueGetter: (params) => params.data.year,
          pinned: "left",
          rowSpan: this.calculateRowSpan, // 20260402 수정
          cellClass: "year-cell",
          // rowSpan: (params) => this.useNewSeListGrid ? this.calculateRowSpan(params) : 1,
          // cellClass: () => this.useNewSeListGrid ? "year-cell" : "",
          width: 22,
          maxWidth: 22,
          flex: 0.5,
          suppressSizeToFit: true,
          cellStyle: this.getRowStyleForGrid2,
        }, // 년도 열
        {
          headerName: "",
          field: "gubun",
          pinned: "left",
          width: 69,
          cellStyle: this.getRowStyleForGrid2,
          tooltipValueGetter: (params) => {
            if (
              params.data &&
              [
                "예정약금",
                "실제약금",
                "매출액",
                "수수료",
                "판가",
                "상계금액",
                "상계차액",
              ].includes(params.data.gubun)
            ) {
              return "단위: 원/10,000";
            }
          },
        },
        // 월별 컬럼 정의 (반복문 사용)
        ...[...Array(12).keys()].map((i) => ({
          headerName: `${i + 1}월`,
          field: `${i + 1}month`,
          flex: 1,
          valueFormatter: this.commonValueFormatter, // 공통 포맷터 사용
          cellStyle: this.commonCellStyle, // 공통 셀 스타일 사용
          editable: (params) => {
            const {
              // EMP_CLASS_NM: empClassNm,
              // OGN_FG: ognFg,
              EMP_DEPT_NM: empDeptNm,
            } = this.userInfo ?? {};

            // const EMP_CLASS_NM = ["부회장", "대표이사", "본부장"];
            const EMP_DEPT_NM = ["관리자팀"];
            // const OGN_FG = "00";

            // const isEmpClassNm = EMP_CLASS_NM.includes(empClassNm);
            // const isOgnFg = ognFg !== OGN_FG;
            const isEmpDeptNm = EMP_DEPT_NM.includes(empDeptNm);

            // const isEditable = isEmpClassNm || isOgnFg || isEmpDeptNm;
            const isEditable = isEmpDeptNm;

            if (!isEditable) return false;
            return ["경영지도", "사업주명", "부점장명"].includes(
              params.data.gubun,
            );
          },
        })),
        {
          headerName: "합계",
          field: "totalCnt",
          flex: 1,
          valueFormatter: this.commonValueFormatter, // 공통 포맷터 사용
          cellStyle: this.commonCellStyle,
        },
      ],

      gridOptions2: {
        // enableSorting: true,
        // animateRows: true,
        quickFilterText: "",
        suppressNoRowsOverlay: true, // 데이터가 없을 때 오버레이 숨김
        // tooltipShowMode: "whenTruncated",
        tooltipShowDelay: 0,
        suppressRowTransform: true, // 행 병합 시 필수 (렌더링 최적화 및 오류 방지)
        defaultColDef: {
          resizable: false, // 열 크기 조정 가능
          sortable: false, // 정렬 가능
          tooltipValueGetter: (params) => params.value,
        },
        getRowStyle: (params) => {
          if (!params.data || !params.data.year) {
            return null; // 데이터가 없으면 기본 스타일 반환
          }

          const currentYear = new Date().getFullYear();
          const currentYY = parseInt(currentYear.toString().substring(2, 4));

          let yearStr = params.data.year.toString().replace("년", "");
          if (yearStr.length === 4) {
            yearStr = yearStr.substring(2, 4);
          }
          const yearYY = parseInt(yearStr);
          const diff = currentYY - yearYY;

          if (diff === 7) {
            return { background: "#97ecff" };
          } else if (diff === 6) {
            return { background: "#b4bfff" };
          } else if (diff === 5) {
            return { background: "#ead6bf" };
          } else if (diff === 4) {
            return { background: "#bef29e" };
          } else if (diff === 3) {
            return { background: "#fff0fd" };
          } else if (diff === 2) {
            return { background: "#dcf3fc" };
          } else if (diff === 1) {
            return { background: "#f1fcb8" };
          } else if (diff === 0) {
            return { background: "#c8fdd1" };
          }
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        headerHeight: 20,
      },

      rowHeight: window.innerWidth > 1024 ? 20 : 15.5,
    };
  },

  created() {

  },

  mounted() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }
    this.fetchBidRooms();
    this.fetchCenterList();
  },
  watch: {
    selectedBranch(newBranchCd) {
      // 본부가 선택되면 팀 목록을 불러옵니다.
      if (newBranchCd) {
        this.fetchTeamList(newBranchCd).then(() => {
          // 사용자가 직접 본부를 변경했을 때만 매장 선택을 초기화
          if (this.userInfo.OGN_FG === "00") {
            this.selectedTeam = "";
          }
        });
      } else {
        this.teamList = [];
        this.selectedTeam = "";
      }
    },
    selectedTeam(newShopCd) {
      if (newShopCd && newShopCd !== "00") {
        const team = this.teamList.find((t) => t.SHOP_CD === newShopCd);
        if (team) {
          const teamName = `(${team.VAN_BIZ_NO}) ${team.SHOP_NM}`;
          if (this.teamSearch !== teamName) {
            this.teamSearch = teamName;
          }
          if (this.selectedBranch === "전체") {
            this.selectedBranch = team.BRANCH_CD;
          }
        }
      } else {
        if (this.teamSearch !== "") {
          this.teamSearch = "";
        }
      }
    },
    dpAmtCurrentYear(val) {
      this.dpAmtCurrentYear = this.formatNumber(val);
    },
    dpAmtNextYear(val) {
      this.dpAmtNextYear = this.formatNumber(val);
    },
  },
  methods: {
    handleTeamChange() {
      const team = this.teamList.find((t) => t.SHOP_CD === this.teamSearch);
      if (team) {
        // 본부가 '전체'일 경우 선택된 매장의 본부로 변경
        if (this.selectedBranch === "전체") {
          this.selectedBranch = team.BRANCH_CD;
        }
      }
    },
    async handleTeamSelection(pref) {
      const selected = this.proposalInfo[pref].teamSearch;

      const team = this.teamList.find(
        (item) => `(${item.VAN_BIZ_NO}) ${item.SHOP_NM}` === selected,
      );

      if (team) {
        this.proposalInfo[pref].storeNo = team.VAN_BIZ_NO;
        this.proposalInfo[pref].storeNm = team.SHOP_NM;
        this.proposalInfo[pref].storeCd = team.SHOP_CD;

        await this.fetchAmount(pref, team.SHOP_CD);
        
        // 선택된 매장의 최고수량 조회
        if (pref !== 1) {
          await this.detailsQty(pref, team.SHOP_CD);
        }
      } else {
        // 일치하는 매장이 없으면 초기화
        this.proposalInfo[pref].storeNo = "";
        this.proposalInfo[pref].storeNm = "";
        this.proposalInfo[pref].storeCd = "";
        if(pref === 2){
          this.detailMaxQtyByMonth2 = {};
          this.proposalInfo[pref].planAmt = "";
        } else if(pref === 3){
          this.detailMaxQtyByMonth3 = {};
          this.proposalInfo[pref].planAmt = "";
        }
      }
    },
    sumQty(pref) {
      return Object.values(this.proposalQty[pref] || {}).reduce(
        (s, v) => s + Number(v || 0),
        0,
      );
    },
    async fetchCenterList() {
      try {
        const res = await axios.get("/api/brListPage/centerList");
        this.branchList = res.data;
        if (this.branchList.length > 0) {
          this.selectedBranch = this.branchList[0].BRANCH_CD;
        }
      } catch (error) {
        console.error("본부 목록 로딩 실패:", error);
        alert("본부 목록을 불러오는 데 실패했습니다.");
      }
    },
    async fetchTeamList(branchCd) {
      try {
        const res = await axios.get(
          `/api/brListPage/teamList?branchCd=${branchCd}`,
        );
        this.teamList = res.data;
      } catch (error) {
        console.error("팀 목록 로딩 실패:", error);
        this.teamList = [];
      }
    },
    async fetchBidRooms() {
      try {
        const response = await axios.get("/api/brListPage/bidList", { 
          params: {
            ognFg: this.userInfo.OGN_FG,
            showConfirmed: this.showConfirmed,
          }
        });
        this.bidRooms = response.data;
      } catch (error) {
        console.error("Error fetching bid rooms:", error);
      }
    },
    isDeadlinePassed(deadline) {
      return new Date() > new Date(deadline);
    },
    selectAnnouncement(item) {
      if (this.isDeadlinePassed(item.DEADLINE)) {
        // 마감 시간 후
        alert("청약 마감일이 지나 청약 할 수 없습니다.")
        return;
      }
      this.selectedAnnouncement = item;
      this.bidId = item.BID_ID;
      this.bidNm = item.BID_NM;
      this.bidShop = item.SHOP_NM;
      this.bidBranch = item.BRANCH_NM;
      this.bidBizNo = item.VAN_BIZ_NO;
      // this.selectedImageUrl = item.IMAGE_URL;
      this.bidShopCd = item.SHOP_CD;
      this.detailWrite = false; // 상세 화면 표시
      this.showApplyList = false; // 상세 화면 표시
      this.detailsQty(1, this.bidShopCd);
      this.applicationHistory();
    },
    applicationHistory() {
      // 신청 이력 조회
      axios
        .get(
          `/api/brListPage/getBidApply/${this.bidId}/${this.userInfo.userId}`,
        )
        .then((res) => {
          if (res.data.success && res.data.data) {
            const apply = res.data.data;
            this.applyId = apply.APPLY_ID;
            this.ownerNm = apply.OWNER_NM;
            this.userNm = apply.CANDIDATE_NM;
            this.userAge = apply.CANDIDATE_AGE;
            this.currentShop = apply.CURRENT_SHOP;
            this.phoneNo = apply.PHONE_NO;
            this.bidEtc = apply.ETC;
          } else {
            this.applyId = null;
            this.ownerNm = "";
            this.userNm = "";
            this.userAge = "";
            this.currentShop = "";
            this.phoneNo = "";
            this.bidEtc = "";
          }
        })
        .catch((err) => {
          console.error("신청 이력 조회 실패:", err);
        });
    },

    async submitBid() {
      if (!this.userNm || !this.userAge || !this.currentShop || !this.phoneNo) {
        alert("모든 필수 항목을 입력해 주세요.");
        return;
      }

      const hasHistory = !!this.applyId;
      const message = hasHistory
        ? "수정 및 상세정보를 입력하시겠습니까?"
        : "입력하신 정보로 청약을 신청하시겠습니까?";

      if (!confirm(message)) return;

      try {
        const payload = {
          applyId: this.applyId,
          bidId: this.bidId,
          ownerNm: this.ownerNm,
          userNm: this.userNm,
          userAge: this.userAge,
          currentShop: this.currentShop,
          phoneNo: this.phoneNo,
          bidEtc: this.bidEtc,
          userId: this.userInfo?.userId,
        };
        
        const res = await axios.post("/api/brListPage/submitBid", payload);

        if (res.applyId) {
          alert("청약 신청이 정상적으로 완료되었습니다.");
        }

        this.selectedAnnouncement = null; // 선택 초기화
        this.showApplyList = false;
        this.detailWrite = true; // 상세 화면 표시
        this.applyId = res.data.applyId || null;
        // 초기 proposalQty 객체 생성
        await this.fetchBidRooms();
        await this.loadProposalQty(this.applyId);
        await this.loadProposalStore(this.applyId);
        await this.loadProposalSign(this.applyId);
        if (!this.proposalInfo[1]?.storeNm) {
          this.proposalInfo[1] = {
            storeNm: this.bidShop,
            storeNo: this.bidBizNo,
            storeCd: this.bidShopCd,
          };
        }
        await this.fetchAmount(1, this.bidShopCd);
      } catch (error) {
        console.error("청약 신청 오류:", error);
        alert("신청 처리 중 오류가 발생했습니다.");
      }
    },

    async loadProposalQty(applyId) {
      if (!applyId) {
        return;
      }

      try {
        // 조회 시작할 때 무조건 초기화
        this.resetProposalStructures();

        const res = await axios.get(`/api/brListPage/getBidProposalQty/${applyId}`);
        if (res.data.success && res.data.data) {
          const rows = res.data.data;

          if (rows.length > 0) {
            rows.forEach((r) => {
              this.proposalQty[r.PREFERENCE][r.MONTH] = r.QTY;
              const key = `${r.MONTH}month`;
              if (r.PREFERENCE === 1) {
                this.detailMaxQtyByMonth[key] = r.MAX_QTY;
              } else if (r.PREFERENCE === 2) {
                this.detailMaxQtyByMonth2[key] = r.MAX_QTY;
              } else if (r.PREFERENCE === 3) {
                this.detailMaxQtyByMonth3[key] = r.MAX_QTY;
              }
            });

            this.detailMaxQtyByMonth.totalCnt = this.sumMax(this.detailMaxQtyByMonth);
            this.detailMaxQtyByMonth2.totalCnt = this.sumMax(this.detailMaxQtyByMonth2);
            this.detailMaxQtyByMonth3.totalCnt = this.sumMax(this.detailMaxQtyByMonth3);
          } else {
            // 데이터가 없을 때도 모든 구조 초기화
            this.proposalQty = { 1: {}, 2: {}, 3: {} };

            // 1번 지망은 최고수량 기본값으로 세팅
            this.detailMaxQtyByMonth = this.getDetailMaxQtyByMonth();

            // 2, 3번 지망은 빈 구조로 초기화
            this.detailMaxQtyByMonth2 = this.initMaxStructure();
            this.detailMaxQtyByMonth3 = this.initMaxStructure();
          }
        }
      } catch (err) {
        console.error("제안 수량 조회 오류:", err);
        this.resetProposalStructures();
      }
    },

    resetProposalStructures() {
      this.proposalQty = { 1: {}, 2: {}, 3: {} };
      this.detailMaxQtyByMonth = this.initMaxStructure();
      this.detailMaxQtyByMonth2 = this.initMaxStructure();
      this.detailMaxQtyByMonth3 = this.initMaxStructure();
    },

    ensureProposalQtyStructure() {
      if (!this.proposalQty) {
        this.proposalQty = {};
      }
      if (!this.proposalQty[this.currentYearVal]) {
        this.proposalQty[this.currentYearVal] = {};
      }
      if (!this.proposalQty[this.nextYearVal]) {
        this.proposalQty[this.nextYearVal] = {};
      }
    },

    initMaxStructure() {
      return {
        "1month": 0,
        "2month": 0,
        "3month": 0,
        "4month": 0,
        "5month": 0,
        "6month": 0,
        "7month": 0,
        "8month": 0,
        "9month": 0,
        "10month": 0,
        "11month": 0,
        "12month": 0,
        totalCnt: 0,
      };
    },

    sumMax(maxObj) {
      return Object.keys(maxObj)
        .filter((k) => k.endsWith("month"))
        .reduce((sum, key) => sum + (Number(maxObj[key]) || 0), 0);
    },

    async loadProposalStore(applyId) {
      if (!applyId) return;

      try {
        const res = await axios.get(
          `/api/brListPage/getBidProposalStore/${applyId}`,
        );
        if (res.data.success && res.data.data) {
          const rows = res.data.data;
          if (rows.length > 0) {
            this.proposalInfo = { 1: {}, 2: {}, 3: {} };
            
            rows.forEach((r) => {
            this.proposalInfo[r.PREFERENCE] = {
              storeNo: r.VAN_BIZ_NO,
              storeNm: r.SHOP_NM,
              storeCd: r.SHOP_CD,
              agreedAmt: this.formatNumber(r.AGREED_AMT),
              planAmt: this.formatNumber(r.PLAN_AMT),
            };
          });
        } else {
            this.proposalInfo = { 1: {}, 2: {}, 3: {} };
        }
      }
      } catch (err) {
        console.error("매장 조회 오류:", err);
      }
    },

    async loadProposalSign(applyId) {
      if (!applyId) return;

      try {
        this.ensureProposalSignStructure();
        const res = await axios.get(
          `/api/brListPage/getBidProposalSign/${applyId}`,
        );
        if (res.data.success && res.data.data && res.data.data.length > 0) {
          const row = res.data.data[0];

          this.proposalDate = row.PROPOSAL_DATE;
          this.userNm = row.PROPOSER_NAME;
          this.phoneNo = row.PHONE_NO;
          if (row.PROPOSAL_DATE) {
            const d = row.PROPOSAL_DATE;
            this.proposalDate = `${d.substring(0, 4)}-${d.substring(
              4,
              6,
            )}-${d.substring(6, 8)}`;
          }
          // 서명 데이터 (백엔드에서 이미 변환된 DataURL)
          this.signatureDataUrl = row.USER_SIGN;
        }
      } catch (err) {
        console.error("제안 서명 조회 오류:", err);
        this.ensureProposalSignStructure();
      }
    },

    ensureProposalSignStructure() {
      this.dpAmtCurrentYear = "";
      this.dpAmtNextYear = "";
      this.proposalDate = "";

      this.signatureDataUrl = null;
    },

    async handleRowClick(applyId) {
      // 두 메서드를 함께 호출
      this.userNm = "";
      this.phoneNo = "";
      applyId;
      await this.loadProposalQty(applyId);
      await this.loadProposalStore(applyId);
      await this.loadProposalSign(applyId);
      this.showRightDetails = true;
    },

    closeForm() {
      this.selectedAnnouncement = null; // 폼 닫기
      this.bidNm = "";
      this.bidShop = "";
      this.showApplyList = false;
      this.showRightDetails = false;
    },
    closeDetail() {
      this.detailWrite = false;
    },
    openPopup() {
      this.newAnnouncement = {
        bidNm: "",
        shopNm: "",
        deadline: "",
        imageFile: null,
      }
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
      this.editMode = false;
      this.editingBidId = null;
      this.newAnnouncement = {
        bidNm: "",
        shopNm: "",
        deadline: "",
        imageFile: null,
      };

      this.selectedBranch = "";
      this.teamSearch = "";
      this.selectedShopCd = "";
    },
    handleFileUpload(event) {
      this.newAnnouncement.imageFile = event.target.files[0];
    },
    toKSTString(date) {
      const tzOffset = date.getTimezoneOffset() * 60000;
      const localTime = new Date(date.getTime() - tzOffset);
      return localTime.toISOString().slice(0, 19).replace("T", " ");
    },
    async saveAnnouncement() {
      const missingFields = [];

      if (!this.newAnnouncement.bidNm) {
        missingFields.push("공고명");
      }

      if (this.selectedBranch === "00") {
        missingFields.push("본부");
      }

      if (!this.teamSearch) {
        missingFields.push("매장명");
      }

      if (!this.newAnnouncement.deadline) {
        missingFields.push("마감일시");
      }

      if (missingFields.length > 0) {
        alert(
          "다음 항목을 입력해주세요:\n- " +
          missingFields.join("\n- ")
        );
        return;
      }

      // 선택된 매장 찾기
      const selectedTeam = this.teamList.find(
        (b) =>
          `(${b.VAN_BIZ_NO}) ${b.SHOP_NM}` === this.teamSearch
      );

      if (!selectedTeam) {
        alert("매장을 정확하게 선택해주세요.");
        return;
      }

      // 선택된 본부 찾기
      const selectedBranchData = this.branchList.find(
        (b) => b.BRANCH_CD === this.selectedBranch
      );

      const payload = {
        // 수정 시 사용
        bidId: this.editingBidId,

        bidNm: this.newAnnouncement.bidNm,

        branchCd: this.selectedBranch,

        branchNm: selectedBranchData?.BRANCH_NM,

        shopCd: selectedTeam.SHOP_CD,

        shopNm: selectedTeam.SHOP_NM,

        vanBizNo: selectedTeam.VAN_BIZ_NO,

        deadline: this.toKSTString(
          new Date(this.newAnnouncement.deadline)
        ),

        userId: this.userInfo?.userId,
      };

      // 신규 / 수정에 따라 확인 문구 변경
      const confirmMessage = this.editMode
        ? "입력하신 공고를 수정하시겠습니까?"
        : "입력하신 공고를 등록하시겠습니까?";

      if (!confirm(confirmMessage)) {
        return;
      }

      try {
        if (this.editMode) {
          // 공고 수정
          await axios.put(`/api/brListPage/bidUpdate/${this.editingBidId}`, payload);

          alert("공고가 수정되었습니다.");
        } else {
          // 공고 신규 등록
          await axios.post("/api/brListPage/bidCreate", payload);

          alert("공고가 등록되었습니다.");
        }

        // 팝업 닫기
        this.closePopup();

        // 공고 목록 다시 조회
        await this.fetchBidRooms();

      } catch (error) {
        console.error(
          this.editMode
            ? "공고 수정 오류:"
            : "공고 등록 오류:",
          error
        );

        alert(
          this.editMode
            ? "수정 중 오류가 발생했습니다."
            : "등록 중 오류가 발생했습니다."
        );
      }
    },
    async applyList(item) {
      try {
        const res = await axios.get(`/api/brListPage/applyList/${item.BID_ID}`);
        this.applyListData = res.data; // 리스트 데이터 저장
        this.bidShop = item.SHOP_NM;
        this.showApplyList = true;
        this.selectedAnnouncement = false;
        this.showRightDetails = false;
      } catch (err) {
        console.error("청약 리스트 불러오기 오류:", err);
      }
    },

    async saveProposal() {
      // 서명 먼저 저장
      if (this.$refs.signaturePad) {
        const pad = this.$refs.signaturePad;
        if (pad.isEmpty()) {
          alert("서명을 작성해주세요.");
          return;
        }
      }
        
      if (!this.proposalDate) {
        alert("청약 일자를 입력해주세요.");
        return;
      }
      if (!this.userNm) {
        alert("제안자명을 입력해주세요.");
        return;
      }
      if (!this.phoneNo) {
        alert("핸드폰 번호를 입력해주세요.");
        return;
      }

      let signature;

      if (this.signatureDataUrl) {
        // 기존 서명 이미지가 이미 있는 경우 → 그대로 사용
        signature = this.signatureDataUrl;
      } else if (this.$refs.signaturePad) {
        // 새로 작성한 경우 → 캔버스에서 추출
        const canvas = this.$refs.signaturePad.$el.querySelector("canvas");
        signature = canvas.toDataURL("image/png");
      } else {
        // 둘 다 없는 경우 → null 처리
        signature = null;
      }

      // 월별 제안 수량 payload (T_BID_PROPOSAL_QTY)
      const qtyPayload = [];
      for (let pref = 1; pref <= 3; pref++) {
        // const hasData = Object.values(this.proposalQty[pref] || {}).some(
        //   (v) => v && Number(v) > 0,
        // );
        // if (pref !== 1 && !hasData) continue; // 값 없으면 skip
        
        // 매장지망 정보있으면 무조건 1월~12월 체크
        const info = this.proposalInfo[pref];
        if (!info || !info.storeNo || !info.storeNm) continue;

        for (let month = 1; month <= 12; month++) {
          const qty = Number(this.proposalQty[pref]?.[month] ?? 0);
          if (qty <= 0) {
            alert(`${pref}지망 ${month}월 데이터가 입력되지 않았습니다.`);
            return;
          }
          const maxQty =
            (pref === 1
              ? this.detailMaxQtyByMonth
              : pref === 2
              ? this.detailMaxQtyByMonth2
              : this.detailMaxQtyByMonth3)[`${month}month`] || 0;

          qtyPayload.push({
            bidId: this.bidId,
            applyId: this.applyId,
            preference: pref,
            month,
            qty: Number(qty),
            maxQty: Number(maxQty),
            userId: this.userInfo?.userId || null,
          });
        }
      }

      // 지망별 매장/약정금액 payload (T_BID_PROPOSAL_STORE)
      const storePayload = [];
      for (let pref = 1; pref <= 3; pref++) {
        const info = this.proposalInfo[pref];
        if (!info || !info.storeNo || !info.storeNm) continue; // 값 없으면 skip

        if (!info.agreedAmt) {
         alert(`${pref}지망 매장의 약정금액을 입력해주세요.`);
          return; // 함수 자체를 중단 (필요하다면 break로 루프만 중단)
        }

        // agreedAmt < planAmt 체크 // 콤마 제거 후 숫자 변환
        const agreedAmt = Number(String(info.agreedAmt).replace(/,/g, "")) || 0;
        const planAmt   = Number(String(info.planAmt).replace(/,/g, "")) || 0;

        if (agreedAmt < planAmt) {
          alert(`${pref}지망 매장의 제안 약정금액은 약점금액보다 작을 수 없습니다.`);
          return; // 함수 중단
        }

        storePayload.push({
          bidId: this.bidId,
          applyId: this.applyId,
          preference: pref,
          vanBizNo: this.proposalInfo[pref]?.storeNo || "",
          shopNm: this.proposalInfo[pref]?.storeNm || "",
          shopCd: this.proposalInfo[pref]?.storeCd || "",
          agreedAmt, 
          planAmt,
          userId: this.userInfo?.userId || null,
        });
      }

      // 제안자 공통 정보 payload (T_BID_PROPOSAL_SIGN)
      const signPayload = {
        bidId: this.bidId,
        applyId: this.applyId,
        proposerName: this.userNm,
        phoneNo: this.phoneNo,
        proposalDate: this.proposalDate.replace(/-/g, ""), // 날짜 입력값
        signature: signature, // 캔버스에서 받아온 base64 이미지
        userId: this.userInfo?.userId || null,
      };

      if (!confirm("입력하신 내용을 청약 신청 하시겠습니까?")) return;

      try {
        await axios.post("/api/brListPage/bidProposalQtySave", qtyPayload);
        await axios.post("/api/brListPage/bidProposalStoreSave", storePayload);
        await axios.post("/api/brListPage/bidProposalSignSave", signPayload);
        alert("저장 완료");
        this.detailWrite = false;
      } catch (err) {
        console.error("저장 오류:", err);
        alert("저장 실패");
      }
    },

    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.signatureDataUrl = "";
    },

    editSignature() {
      this.signatureDataUrl = null; // 다시 입력 모드로
    },

    formatAmount(pref, event) {
      let value = event.target.value.replace(/[^0-9]/g, ""); // 숫자만 추출
      if (value) {
        // 천 단위 콤마 추가
        value = Number(value).toLocaleString();
      }
      this.proposalInfo[pref].agreedAmt = value;
    },

    formatNumber(val) {
      if (!val) return "";
      const num = String(val).replace(/[^0-9]/g, "");
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    saveConfirm() {
      // 체크된 항목 찾기
      const checkedList = this.applyListData.filter((apply) => apply.checked);

      // 체크된 항목이 없거나 2개 이상이면 걸러주기
      if (checkedList.length === 0) {
        alert("확정할 지원자를 선택하세요.");
        return;
      }
      if (checkedList.length > 1) {
        alert("지원자는 한 명만 선택할 수 있습니다.");
        return;
      }

      const selectedApply = checkedList[0];

      // 서버 저장 로직 
      axios
        .post("/api/brListPage/saveConfirm", {
          bidId: selectedApply.BID_ID,
          applyId: selectedApply.APPLY_ID,
          confirmedId: this.userInfo.userId, // 확정자 ID 등 필요 데이터
          confirmedNm: this.userInfo.EMP_NM, // 확정자 ID 등 필요 데이터
        })
        .then((res) => {
          if (res.data.success) {
            alert("확정되었습니다.");
            // 상태 업데이트
            selectedApply.CONFIRMED_ID = 1;
          } else {
            alert("저장 실패: " + res.data.message);
          }
        })
        .catch((err) => {
          console.error("확정 저장 오류:", err);
          alert("저장 중 오류가 발생했습니다.");
        });
    },
    async fetchAmount(pref, shopCd){
      try {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const saleMm = `${year}${month}`; // 예: 202607

        const response = await axios.get(
          `/api/brListPage/fetchAmount?shopCd=${shopCd}&saleMm=${saleMm}`
        );
        
      if (response.data && response.data.length > 0) {
        const data = response.data[0];
        this.proposalInfo[pref].planAmt = this.formatNumber(data.PLAN_AMOUNT);
      } else {
        this.proposalInfo[pref].planAmt = "";
      }
        
      } catch (error) {
        console.error("데이터 조회 오류:", error);
      }
    },

    // 8년수량 시작
    async detailsQty(pref, shopCd) {
      try {
        const response = await axios.get(
          `/api/seListPage/detailsQty?shopCd=${shopCd}`,
        );
        const data = response.data;
        this.proposalInfo[pref].storeCd = shopCd;
        // 응답 데이터가 배열인지 확인
        this.rowData2 = this.transformQtyData(data);
        if (pref === 1) {
          this.detailMaxQtyByMonth = this.getDetailMaxQtyByMonth();
        } else if (pref === 2) {
          this.detailMaxQtyByMonth2 = this.getDetailMaxQtyByMonth();
        } else if (pref === 3) {
          this.detailMaxQtyByMonth3 = this.getDetailMaxQtyByMonth();
        }
      } catch (error) {
        console.error("데이터 조회 오류:", error);
      }
    },
    transformQtyData(data) {
      const transformed = {};
      const currentYear = new Date().getFullYear(); // 현재 연도

      // 최고 판매수량 계산
      const maxSaleQtyByMonth = {};

      if (!Array.isArray(data)) {
        console.error("transformData: 입력 데이터가 배열이 아닙니다.", data);
        return [];
      }

      data.forEach((row) => {
        if (!row || !row.SALE_MM) {
          // 문제가 있는 데이터 건너뛰기
          return; // 현재 반복 건너뛰고 다음 row 처리
        }

        const year = parseInt(row.SALE_MM.substring(0, 4)); // 년도 추출
        const month = parseInt(row.SALE_MM.substring(4, 6)); // 월 추출
        const yearYY = year.toString().substring(2, 4); // 연도 YY 추출

        // 월별 최고 판매수량 계산
        if (year <= currentYear - 1) {
          if (
            !maxSaleQtyByMonth[month] ||
            maxSaleQtyByMonth[month] < parseInt(row.SALE_QTY)
          ) {
            maxSaleQtyByMonth[month] = parseInt(row.SALE_QTY);
          }
        }
        if (!transformed[year]) {
          if (year === currentYear) {
            transformed[year] = {
              ownerName: { year: `${year}년`, gubun: "사업주명" },
              manageGuid: { year: `${year}년`, gubun: "컨설턴트" },
              maxQty: { year: `${year}년`, gubun: "최고수량" },
              contractQuantity: { year: `${year}년`, gubun: "계약수량" },
              contractDiff: { year: `${year}년`, gubun: "계약차이" },
              salesQty: { year: `${year}년`, gubun: "판매수량" },
              // maxRate: { year: `${year}년`, gubun: "최고달률" },
              qtyDiff: { year: `${year}년`, gubun: "최고과부"},
              contractSubtraction: { year: `${year}년`, gubun: "계약과부" },
              // contractRate: { year: `${year}년`, gubun: "약정달률" },
              averaScore: { year: `${year}년`, gubun: "평균점수" },
              // 회장님 지시사항 반영 20260204 "매출액", "수수료", "수수료율", "보증금액", "재고수량", "이월수량", "이월비율"  추가
              salesRevenue: { year: `${year}년`, gubun: "매출액" },
              unitPrice: { year: `${year}년`, gubun: "판가" },
            };
          } else {
            transformed[year] = {
              ownerName: { year: `${yearYY}년`, gubun: "사업주명" },
              salesQty: { year: `${yearYY}년`, gubun: "판매수량" },
              qtyDiff: { year: `${yearYY}년`, gubun: "수량차이" },
            };
          }
        }
      
        // 하위 객체 초기화 확인
        if (!transformed[year].salesQty) {
          transformed[year].salesQty = {};
        }
        if (!transformed[year].qtyDiff) {
          transformed[year].qtyDiff = {};
        }

        if (year === currentYear) {
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            if (!transformed[year].contractQuantity[monthKey]) {
              transformed[year].contractQuantity[monthKey] = 0;
            }
            if (!transformed[year].contractDiff[monthKey]) {
              transformed[year].contractDiff[monthKey] = 0;
            }
          }
        }

        // 사업주명 추가
        transformed[year].ownerName[`${month}month`] = row.SHOP_MASTER_NM || "";
        
        // 판매수량 추가
        if (row.SALE_QTY != null ) {
          transformed[year].salesQty[`${month}month`] = Math.round(
            row.SALE_QTY,
          );
        }
        if (year === currentYear) {
          const monthKey = `${month}month`;
          const contractQtyValue = Number(row.CONTRACT_QTY ?? 0);
          if (contractQtyValue > 0 || row.CONTRACT_QTY !== undefined) {
            transformed[year].contractQuantity[monthKey] = contractQtyValue;
          }

          transformed[year].manageGuid[`${month}month`] = row.SHOP_CEO_NM || "";
          if (row.SALE_SCORE_AVG != null && !isNaN(Number(row.SALE_SCORE_AVG))) {
            transformed[year].averaScore[`${month}month`] = Math.round(
              row.SALE_SCORE_AVG,
            );
          }
          transformed[year].salesRevenue[`${month}month`] = row.DCM_SALE_AMT;
          // transformed[year].unitPrice[`${month}month`] = (row.DCM_SALE_AMT/ Math.round(row.SALE_QTY)).toFixed(1);
          transformed[year].unitPrice[`${month}month`] = row.UNIT_PRICE ?? "";
        }
      });

      // 특정 연도와 월 키에 대한 판매 수량
      const getQty = (transformed, year, monthKey) => {
        // 옵셔널 체이닝을 사용하여 중첩된 속성에 안전하게 접근
        return parseInt(transformed[year]?.salesQty?.[monthKey] || 0);
      };

      // --- 수량 차이(qtyDiff) 및 최고 수량(maxQty) 계산 ---
      Object.keys(transformed).forEach((yearStr) => {
        const numYear = parseInt(yearStr); // 문자열 연도를 숫자로 변환
        const salesQtyRow = transformed[yearStr]?.salesQty; // salesQty 행을 가져옴



        // --- 수량 차이(qtyDiff) 계산 ---
        if (
          salesQtyRow &&
          numYear >= currentYear - 8 &&
          numYear <= currentYear
        ) {

          // salesQtyRow에 있는 월 키들을 순회
          Object.keys(salesQtyRow).forEach((key) => {
            // 실제 월 키('1month', '12month' 등)만 처리
            if (key.endsWith("month")) {
              const currentSaleQty = parseInt(salesQtyRow[key]) || 0; // 현재 월의 판매 수량
              const monthKey = key; // key는 이미 'Nmonth' 형식임

              let maxSaleQty = 0; // 해당 월의 이전 연도들 중 최고 판매 수량
              let diff = 0; // 수량 차이

              // 연도에 따라 특정 차이 계산 로직 적용 (원본 코드와 동일)
              if (numYear <= currentYear) {
                // 현재 연도: 이전 5개년 중 최고값 계산
                maxSaleQty = Math.max(
                  getQty(transformed, currentYear - 8, monthKey),
                  getQty(transformed, currentYear - 7, monthKey),
                  getQty(transformed, currentYear - 6, monthKey),
                  getQty(transformed, currentYear - 5, monthKey),
                  getQty(transformed, currentYear - 4, monthKey),
                  getQty(transformed, currentYear - 3, monthKey),
                  getQty(transformed, currentYear - 2, monthKey),
                  getQty(transformed, currentYear - 1, monthKey),
                );
                // 현재 연도는 diff === 0 케이스 처리가 원본 로직에 없음
                diff = currentSaleQty - maxSaleQty;
                transformed[yearStr].qtyDiff[monthKey] = diff;
              }
              // 참고: currentYear - 4년 이하의 연도에 대해서는 여기서 qtyDiff가 계산되지 않음
              // DB에서 이전에 설정된 'GAP' 값을 유지
            }
          });
        }

        // --- *현재* 연도의 최고 수량(maxQty) 행 계산 ---
        if (numYear === currentYear) {
          // 현재 연도에 maxQty 객체가 존재하는지 확인하고 없으면 생성
          if (!transformed[yearStr].maxQty) {
            transformed[yearStr].maxQty = {
              year: yearStr.substring(2, 4),
              gubun: "최고수량",
            };
          }

          let totalMaxSaleQty = 0; // 월별 최고 수량의 총합을 저장할 변수
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            // 해당 월에 대해 이전 8개년 간의 최고 판매 수량 계산
            const monthlyMax = Math.max(
              getQty(transformed, currentYear - 8, monthKey),
              getQty(transformed, currentYear - 7, monthKey),
              getQty(transformed, currentYear - 6, monthKey),
              getQty(transformed, currentYear - 5, monthKey),
              getQty(transformed, currentYear - 4, monthKey),
              getQty(transformed, currentYear - 3, monthKey),
              getQty(transformed, currentYear - 2, monthKey),
              getQty(transformed, currentYear - 1, monthKey),
            );
            // 계산된 월별 최고 수량을 현재 연도의 maxQty 행에 할당
            transformed[yearStr].maxQty[monthKey] = monthlyMax;
            totalMaxSaleQty += monthlyMax;

            const contractQtyValue = Number(transformed[yearStr].contractQuantity?.[monthKey] || 0);
            transformed[yearStr].contractDiff[monthKey] = contractQtyValue - monthlyMax;
            
            const salesValue = transformed[yearStr].salesQty?.[monthKey];
            // 판매수량 값이 없으면 빈 문자열, 있으면 차이 계산
            if (salesValue == null || salesValue === "") {
              transformed[yearStr].contractSubtraction[monthKey] = "";
            } else {
              transformed[yearStr].contractSubtraction[monthKey] =
                Number(salesValue) - contractQtyValue;
            }
          }
          // 계산된 총합을 'totalCnt' 필드에 할당
          transformed[yearStr].maxQty["totalCnt"] = totalMaxSaleQty;
        }
      });
      // --- 끝: 수량 차이 및 최고 수량 계산 ---

      // (salesQty, qtyDiff 등의 totalCnt 계산을 위한 후속 루프가 여기에 와야 함)
      Object.keys(transformed).forEach((yearStr) => {
        // 합계를 계산할 모든 관련 타입 포함
        [
          "salesQty",
          "qtyDiff",
          "maxQty",
          "averaScore",
          "salesRevenue",
          "unitPrice",
          "contractQuantity",
          "contractDiff",
          "contractSubtraction",
        ].forEach((type) => {
          const row = transformed[yearStr]?.[type]; // 해당 타입의 행을 안전하게 가져옴
          if (row) {
            // 행이 존재하는 경우에만 계산
            let sum = 0; // 합계를 저장할 변수 초기화
            let count = 0;
            for (let m = 1; m <= 12; m++) {
              // 1월부터 12월까지 반복
              const monthKey = `${m}month`; // 월 키 생성 (예: '1month')
              // 값을 더하기 전에 숫자인지 확인하고, 아니면 0으로 처리
              // const value = parseInt(row[monthKey]) || 0;
              
              let value = row[monthKey];
              
              if(type === "unitPrice" && value != null && value !== "") {
                count++;
                value = parseFloat(value) || 0;
              }else {
                if (type === "averaScore" && value != null && value !== "") {
                  count++;
                }
                value = parseInt(value) || 0;
              }
                sum += value; // 합계 누적
            }
            // row["totalCnt"] = sum; // 계산된 합계를 'totalCnt' 필드에 할당
            if (type === "averaScore" || type === "unitPrice"){
              row["totalCnt"] = count > 0 ? (sum / count).toFixed(1) : "";
            } else {
              row["totalCnt"] = sum; // 계산된 합계를 'totalCnt' 필드에 할당
            }
          }
        });
      });

      // 결과를 배열로 변환
      return Object.keys(transformed)
        .filter((year) => parseInt(year) >= currentYear - 7)
        .map((year) => transformed[year])
        .flatMap((yearData) => Object.values(yearData));
    },
    getDetailMaxQtyByMonth() {
      const currentYear = new Date().getFullYear();
      const currentYearLabel = `${currentYear}년`;
      const row = this.rowData2.find(
        (item) => item.gubun === "최고수량" && item.year === currentYearLabel,
      );

      if (!row) return {};

      return Object.fromEntries(
        Array.from({ length: 12 }, (_, index) => {
          const monthKey = `${index + 1}month`;
          return [monthKey, row[monthKey] ?? ""];
        }).concat([["totalCnt", row.totalCnt ?? ""]]),
      );
    },
    onLeftGridReady(params) {
      this.leftGridApi = params.api;
    },
    getRowStyleForGrid2(params) {
      let style = {}; // 기본 스타일 객체

      if (!params.data) {
        return null; // 데이터가 없으면 기본 스타일 반환
      }

      // 1. gubun 존재 시 텍스트 가운데 정렬 추가
      if (params.data.gubun) {
        style["text-align"] = "center"; // 가운데 정렬 스타일 추가
      }

      // 2. 연도(year) 존재 시 배경색 로직 추가
      if (params.data.year) {
        const currentYearLastTwoDigits = new Date()
          .getFullYear()
          .toString()
          .substring(2, 4); // 현재 연도 YY
        const yearLabel = params.data.year.toString(); // 예: "23년" 또는 "2024년"
        let yearLastTwoDigits = "";

        // 연도 라벨 형식에 따라 YY 추출
        if (yearLabel.endsWith("년")) {
          const yearPart = yearLabel.substring(0, yearLabel.length - 1); // "년" 제거
          if (yearPart.length === 4) {
            // "YYYY" 형식
            yearLastTwoDigits = yearPart.substring(2, 4);
          } else if (yearPart.length === 2) {
            // "YY" 형식
            yearLastTwoDigits = yearPart;
          }
        }

        if (yearLastTwoDigits) {
          const yearDiff =
            parseInt(currentYearLastTwoDigits) - parseInt(yearLastTwoDigits);

          // 연도 차이에 따른 배경색 적용
          let backgroundStyle = {};
          if (yearDiff === 7) backgroundStyle = { background: "#97ecff" };
          else if (yearDiff === 6) backgroundStyle = { background: "#b4bfff" };
          else if (yearDiff === 5) backgroundStyle = { background: "#ead6bf" };
          else if (yearDiff === 4) backgroundStyle = { background: "#bef29e" };
          else if (yearDiff === 3) backgroundStyle = { background: "#fff0fd" };
          else if (yearDiff === 2) backgroundStyle = { background: "#dcf3fc" };
          else if (yearDiff === 1) backgroundStyle = { background: "#f1fcb8" };
          else if (yearDiff === 0) backgroundStyle = { background: "#c8fdd1" };

          // 기존 스타일 객체에 배경색 스타일 병합
          style = { ...style, ...backgroundStyle };
        }
      }

      return Object.keys(style).length > 0 ? style : null;
    },
    commonCellStyle(params) {
      if (!params.data) return null; // 데이터 없으면 null

      const gubun = params.data.gubun;
      const value = params.value;
      const yearLabel = params.data.year.toString(); // 예: "23년" 또는 "2024년"
      const yearPart = yearLabel.substring(0, yearLabel.length - 1); // "년" 제거
      let style = {};
      // 예: 짝수/홀수 행 색상 다르게

      if (gubun ==  "최고과부" || gubun ==  "약정차이" || gubun ==  "계약차이" || gubun ==  "계약과부") {
          style.color = value < 0 ? "blue" : "red";
        }
        if(yearPart.length === 2) {
          if (gubun == "사업주명"){
            style.textAlign = "center";
          }
          if(gubun == "판매수량"){
            style.backgroundColor = "#ffffff";
          }
          if(params.colDef.field === 'totalCnt'){
            if(gubun == "판매수량"){
              style.backgroundColor = "#ffff00";
            }
          }
        }else {
          if (gubun == "사업주명"){
            style.textAlign = "center";
          }
          if (gubun == "컨설턴트"){
            style.backgroundColor = "#ffe8e8";
            style.textAlign = "center";
          }
          // if (gubun == "최고수량" || gubun == "매출액"){
          if (gubun == "최고수량" || gubun == "계약차이" || gubun == "평균점수" || gubun == "판가"){
            style.backgroundColor = "#ffffff";
          }
          if(gubun == "최고과부"){
            style.backgroundColor = "#ffff00";
          }
          if(params.colDef.field === 'totalCnt'){
            if(gubun == "최고수량" || gubun == "최고과부"){
              style.backgroundColor = "#ffc080";
            }
            if(gubun == "판매수량"){
              style.backgroundColor = "#ffff00";
            }
          }
        }
      return style; // 기본 스타일
    },
    calculateRowSpan(params) {
      if (!params.data || !params.data.year) return 1;
      const year = params.data.year;
      const rowIndex = params.node.rowIndex;

      // 이전 행과 값이 같으면 1 반환 (병합된 셀의 일부로 처리됨)
      if (rowIndex > 0) {
        const prevNode = params.api.getDisplayedRowAtIndex(rowIndex - 1);
        if (prevNode && prevNode.data && prevNode.data.year === year) {
          return 1;
        }
      }

      // 이후 행들과 값이 같은지 확인하여 병합할 행 수 계산
      let count = 1;
      let nextIndex = rowIndex + 1;
      let nextNode = params.api.getDisplayedRowAtIndex(nextIndex);

      while (nextNode && nextNode.data && nextNode.data.year === year) {
        count++;
        nextIndex++;
        nextNode = params.api.getDisplayedRowAtIndex(nextIndex);
      }
      return count;
    },
    // 8년수량 끝

    toggleConfirmed() {
      this.showConfirmed = !this.showConfirmed;
      this.fetchBidRooms();
      this.closeForm();
      this.showConfirmList = false;
    },
    toggleConfirmList() {
      this.showConfirmList = true;
      this.fetchConfirmList();
      this.closeForm();
    },
    async fetchConfirmList() {
      try {
        const response = await axios.get("/api/brListPage/confirmList", );
        this.confirmList = response.data;
      } catch (error) {
        console.error("Error fetching bid rooms:", error);
      }
    },

    openAnnouncementEdit(item) {
      if(this.userInfo && !['younghee9580','TB관리자'].includes(this.userInfo.userId)) return;
      this.editMode = true;
      this.editingBidId = item.BID_ID;

      // 공고명
      this.newAnnouncement.bidNm = item.BID_NM || "";

      // 본부
      this.selectedBranch = item.BRANCH_CD || "";

      // 매장
      this.teamSearch = item.VAN_BIZ_NO && item.SHOP_NM
        ? `(${item.VAN_BIZ_NO}) ${item.SHOP_NM}`
        : "";

      // 마감일
      this.newAnnouncement.deadline = this.toDatetimeLocal(
        item.DEADLINE
      );

      // 팝업 열기
      this.showPopup = true;
    },

    toDatetimeLocal(value) {
      if (!value) return "";

      return value.replace(" ", "T").slice(0, 16);
    },
  },
};
</script>

<style scoped>
.br-list-page {
  padding: 5px;
  font-family: "Malgun Gothic", Arial, sans-serif;
  background-color: #f9f9f9;
  min-height: 80vh;
}
.header-section h3 {
  margin: 5px;
  border-bottom: 2px solid #333;
}
.announcement-box {
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  margin-bottom: 10px;
}
.announcement-header {
  background-color: #fff1b8;
  padding: 5px;
  font-weight: bold;
  font-size: 1rem;
  border-bottom: 1px solid #ffe58f;
  display: flex;
  justify-content: space-between;
}
.announcement-body {
  padding: 10px;
  line-height: 1.6;
  max-height: 120px; /* 일정 높이 */
  overflow-y: auto; /* 내용이 많으면 스크롤 */
}
.announcement-body ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.announcement-body li {
  padding: 10px 0;
  border-bottom: 1px solid #ddd; /* 항목 구분선 */
}
.announcement-body li:last-child {
  border-bottom: none; /* 마지막 항목은 선 제거 */
}
.announcement-body-table {
  width: 100%;
  border-collapse: collapse;
}
.announcement-body-table th,
.announcement-body-table td {
  border: 1px solid #ddd;
  padding: 2px;
  text-align: center;
}
.announcement-row {
  cursor: pointer;
}
.announcement-row:hover {
  background-color: #f8fafc;
}
.bid-form-container {
  background: #fff;
  border: 1px solid #ddd;
  padding: 5px;
  border-radius: 4px;
  margin: 0 auto;
}
.form-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
}
.form-content {
  display: flex;
  gap: 20px;
}
.form-right {
  flex: 0.8; /* 왼쪽 영역 */
}

.form-left {
  flex: 1; /* 오른쪽 영역 */
  display: flex;
  flex-direction: column; /* 세로 방향으로 배치 */
  align-items: stretch;
  justify-content: center;
}
.form-right-details {
  flex: 1; /* 왼쪽 영역 */
}
.form-left-details {
  flex: 0.7; /* 왼쪽 영역 */
}
.right-details-section {
  font-size: 0.75rem;
}
.announcement-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 이미지가 영역을 꽉 채우도록 */
  border: 1px solid #ddd;
  border-radius: 4px;
}
.bid-form-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.bid-form-table th,
.bid-form-table td {
  border: 1px solid #ddd;
  padding: 12px;
}
.bid-form-table th {
  background-color: #f7f7f7;
  width: 120px;
  text-align: center;
}
.bid-form-table input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
}

.list-form-content {
  display: flex;
  gap: 5px;
}

.list-form-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.list-form-table th,
.list-form-table td {
  border: 1px solid #ddd;
  padding: 6px;
  font-size: 0.8rem;
  text-align: center;
}
.list-form-table th {
  background-color: #f7f7f7;
  width: 120px;
  text-align: center;
}
.list-form-table input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
}
.etc-cell {
  max-height: 100px;
  width: 40%;
  overflow-y: auto;
  white-space: pre-line;
}

.form-footer {
  text-align: center;
}
.notice-box {
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  padding: 30px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
  border-radius: 6px;
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
}

.btn-submit {
  background-color: #007bff;
  color: #fff;
  border: none;
  padding: 12px 40px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}
.btn-close {
  margin-left: 10px;
  padding: 12px 40px;
  background-color: #aaa;
  font-size: 1rem;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.btn-close:hover {
  background-color: #888;
}
.btn-select:hover {
  background-color: #389e0d;
}
.btn-submit:hover {
  background-color: #0056b3;
}
.no-announcement {
  color: #999;
  text-align: center;
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-container {
  background: #fff;
  padding: 30px; /* 여백 조금 더 */
  border-radius: 8px;
  width: 500px; /* 전체 팝업 넓이 확대 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* 그림자 효과 */
}
.popup-table {
  width: 100%;
  border-collapse: collapse;
}
.popup-table th,
.popup-table td {
  border: 1px solid #ddd;
}
.popup-table th {
  width: 120px;
  text-align: center;
  background: #f7f7f7;
  padding: 10px;
  border-right: 1px solid #eee;
}
.popup-table td {
  padding: 10px;
}
.popup-table input,
.popup-table select {
  width: 80%; /* 입력창 전체 폭 사용 */
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}
.team-select {
  width: 100%;
}
.branch-select {
  width: 100%;
}
.popup-footer {
  text-align: center;
  margin-top: 20px;
}

.bid-dt-container {
  background: #fff;
  border: 1px solid #ddd;
  padding: 5px;
  border-radius: 4px;
  margin: 0 auto;
  font-weight: bold;
}
.bid-dt-container input {
  border: none;
  border-bottom: 1px solid #333;
  background: transparent;
  width: 120px;
  padding: 4px;
  outline: none;
  font-family: "Malgun Gothic", Arial, sans-serif;
  font-size: 1rem;
}
.bt-title {
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 40px;
  text-align: center;
}
.notice-text {
  border: 1px solid #ccc; /* 테두리 */
  border-radius: 6px; /* 모서리 둥글게 */
  padding: 10px; /* 안쪽 여백 */
  margin: 10px 0; /* 위아래 간격 */
  line-height: 1.8; /* 줄 간격 */
  background-color: #fafafa; /* 은은한 배경 */
}
.bid-dt-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  font-size: 0.95rem;
}

.bid-dt-table th,
.bid-dt-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.bid-dt-table th {
  background-color: #f0f0f0;
  font-weight: 600;
}

.bid-dt-table tr:nth-child(even) {
  background-color: #fafafa;
}

.bid-dt-table input {
  width: 100%;
  padding: 4px;
  border: 1px solid #bbb;
  border-radius: 4px;
  box-sizing: border-box;
  text-align: right;
}
:deep(.ag-br-balham) {
  --ag-cell-horizontal-padding: 2px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

/* grid 헤더 스타일 */
:deep(.ag-br-balham .ag-header-cell-text) {
  color: #333; /* 텍스트 색상 */
  font-size: 0.725rem;
}
/* grid 헤더 스타일 */
:deep(.ag-br-balham .ag-header-cell) {
  background-color: #f7f7f7; /* 밝은 배경색 */
}

/* grid 헤더 텍스트 정렬 */
:deep(.ag-br-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  text-align: center;
}

:deep(.ag-br-balham .ag-cell.ag-column-first.year-cell) {
  font-weight: bold;
  font-size: 0.9rem;
  writing-mode: vertical-rl; /* 세로 쓰기 모드 */
  text-orientation: upright; /* 세로 텍스트 방향 */
  padding-right: 5px;
  width: 20px;
  border-bottom: 1px solid #c0c0c0;
}

/* grid 데이터 셀 스타일 */
:deep(.ag-br-balham .ag-cell) {
  font-size: 0.8rem;
  text-align: right;
  /* padding-right: 3px; */
}
/* grid 헤더 배경색 */
:deep(.ag-br-balham .ag-header-container) {
  /* 헤더 배경색 */
  background-color: #f0f0f0 !important;
}
</style>
<!-- 
<style scoped>

/* =========================================================
   전체 페이지
========================================================= */

.br-list-page {
  padding: 8px;
  min-height: 80vh;

  background: #f5f7fa;
  color: #374151;

  font-family: "Malgun Gothic", Arial, sans-serif;
  font-size: 13px;
  box-sizing: border-box;
}


/* =========================================================
   페이지 제목
========================================================= */

.header-section {
  margin-bottom: 8px;
}

.header-section h3 {
  margin: 0;
  padding: 8px 4px 7px;

  color: #1f2937;
  font-size: 1.15rem;
  font-weight: 700;

  border-bottom: 2px solid #374151;
}


/* =========================================================
   공고 영역
========================================================= */

.announcement-box {
  margin-bottom: 10px;

  background: #fff;
  border: 1px solid #dfe3e8;
  border-radius: 7px;

  overflow: hidden;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.announcement-header {
  min-height: 38px;
  padding: 0 10px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;

  color: #374151;
  font-size: 0.85rem;
  font-weight: 700;
  box-sizing: border-box;
}

.announcement-header > div:first-child {
  display: flex;
  align-items: center;
  gap: 7px;
}

.announcement-header > div:first-child::before {
  content: "";
  width: 7px;
  height: 7px;

  border-radius: 50%;
  background: #64748b;
}

.announcement-body {
  padding: 6px;
  background: #fff;

  overflow-y: auto;
  box-sizing: border-box;
}


/* =========================================================
   공고 테이블
========================================================= */

.announcement-body-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  background: #fff;
}

.announcement-body-table th,
.announcement-body-table td {
  height: 30px;
  padding: 4px 6px;

  border: 1px solid #e5e7eb;

  text-align: center;
  vertical-align: middle;

  font-size: 0.76rem;
  box-sizing: border-box;
}

.announcement-body-table th {
  background: #f3f4f6;
  color: #4b5563;
  font-weight: 700;
}

.announcement-body-table tbody tr {
  transition: background-color 0.15s ease;
}

.announcement-body-table tbody tr:hover {
  background: #f8fafc;
}

.announcement-body-table td strong {
  color: #374151;
  font-weight: 600;
}


/* 마감일 강조 */

.announcement-body-table td:nth-last-child(2) strong {
  color: #dc2626;
  font-weight: 700;
}


/* =========================================================
   상단 버튼
========================================================= */

.btn-add {
  height: 27px;
  margin-left: 4px;
  padding: 0 9px;

  border: 1px solid #cbd5e1;
  border-radius: 5px;

  background: #fff;
  color: #475569;

  font-size: 11px;
  font-weight: 600;

  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-add:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}


/* =========================================================
   공고 선택 버튼
========================================================= */

.btn-select {
  min-width: 62px;
  height: 25px;
  padding: 0 8px;

  border: 0;
  border-radius: 4px;

  background: #3b82f6;
  color: #fff;

  font-size: 11px;
  font-weight: 600;

  cursor: pointer;
  transition: background 0.15s ease;
}

.btn-select:hover {
  background: #2563eb;
}

.announcement-body-table td .btn-select + .btn-select {
  margin-left: 3px;
}


/* =========================================================
   신청서 / 상세 컨테이너
========================================================= */

.bid-form-container {
  margin: 10px 0;
  padding: 10px;

  background: #fff;
  border: 1px solid #dfe3e8;
  border-radius: 7px;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

  box-sizing: border-box;
}


/* =========================================================
   좌우 레이아웃
========================================================= */

.form-content {
  display: flex;
  gap: 12px;
  align-items: stretch;
}

.form-left {
  flex: 1;
  min-width: 0;

  display: flex;
  flex-direction: column;
}

.form-right {
  flex: 0.8;
  min-width: 0;
}

.form-right-details {
  flex: 1;
  min-width: 0;
}

.form-left-details {
  flex: 0.7;
  min-width: 0;
}

.list-form-content {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}


/* =========================================================
   섹션 제목
========================================================= */

.form-title {
  margin: 2px 0 8px;

  color: #374151;
  font-size: 0.9rem;
  font-weight: 700;
  text-align: left;
}

.form-title::before {
  content: "";
  display: inline-block;

  width: 5px;
  height: 14px;

  margin-right: 6px;

  vertical-align: -2px;

  background: #3b82f6;
  border-radius: 2px;
}


/* =========================================================
   신청서 테이블
========================================================= */

.bid-form-table {
  width: 100%;
  margin-bottom: 10px;

  border-collapse: collapse;
  table-layout: fixed;
}

.bid-form-table th,
.bid-form-table td {
  padding: 7px 8px;

  border: 1px solid #e2e8f0;

  font-size: 0.78rem;
  box-sizing: border-box;
}

.bid-form-table th {
  width: 95px;

  background: #f8fafc;
  color: #64748b;

  text-align: center;
  font-weight: 700;
}

.bid-form-table td {
  background: #fff;
  color: #374151;
}

.bid-form-table input {
  width: 100%;
  height: 29px;

  padding: 4px 7px;

  border: 1px solid #d1d5db;
  border-radius: 4px;

  background: #fff;

  font-size: 12px;
  box-sizing: border-box;
  outline: none;
}

.bid-form-table input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.08);
}

.bid-form-table textarea {
  width: 100%;
  padding: 7px;

  border: 1px solid #d1d5db;
  border-radius: 4px;

  font-family: inherit;
  font-size: 12px;

  resize: vertical;
  box-sizing: border-box;
  outline: none;
}

.bid-form-table textarea:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.08);
}


/* =========================================================
   안내문
========================================================= */

.notice-box {
  margin: 8px 0;

  padding: 12px;

  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;

  color: #64748b;

  font-size: 0.78rem;
  line-height: 1.7;
  font-weight: 600;

  text-align: center;
}

.notice-text {
  margin: 8px 0 12px;
  padding: 11px 13px;

  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;

  color: #64748b;

  font-size: 12px;
  line-height: 1.7;

  box-sizing: border-box;
}


/* =========================================================
   버튼 영역
========================================================= */

.form-footer {
  padding: 5px 0;

  text-align: center;
}

.btn-submit,
.btn-close {
  height: 34px;
  padding: 0 22px;

  border: 0;
  border-radius: 5px;

  font-size: 12px;
  font-weight: 700;

  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-submit {
  background: #2563eb;
  color: #fff;
}

.btn-submit:hover {
  background: #1d4ed8;
}

.btn-close {
  margin-left: 6px;
  background: #e5e7eb;
  color: #4b5563;
}

.btn-close:hover {
  background: #d1d5db;
}


/* =========================================================
   신청자 리스트
========================================================= */

.list-form-table {
  width: 100%;
  margin-bottom: 10px;

  border-collapse: collapse;
  table-layout: fixed;
}

.list-form-table th,
.list-form-table td {
  height: 29px;
  padding: 4px 5px;

  border: 1px solid #e2e8f0;

  font-size: 0.76rem;
  text-align: center;
  vertical-align: middle;

  box-sizing: border-box;
}

.list-form-table thead tr {
  background: #f3f4f6 !important;
  color: #475569;
}

.list-form-table thead td {
  background: #f3f4f6;
  font-weight: 700;
}

.list-form-table tbody tr {
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.list-form-table tbody tr:hover {
  background: #f8fafc;
}

.list-form-table input[type="checkbox"] {
  width: 15px;
  height: 15px;

  accent-color: #2563eb;
  cursor: pointer;
}

.etc-cell {
  width: 40%;
  max-height: 60px;

  overflow-y: auto;

  white-space: pre-line;
  word-break: break-word;

  text-align: left !important;
  line-height: 1.4;
}


/* =========================================================
   청약 상세
========================================================= */

.bid-dt-container {
  padding: 12px;

  background: #fff;
  border: 1px solid #dfe3e8;
  border-radius: 7px;

  box-sizing: border-box;
}

.bt-title {
  margin: 4px 0 16px;

  color: #1f2937;

  font-size: 1.35rem;
  font-weight: 700;

  text-align: center;
}


/* =========================================================
   지망 신청 영역
========================================================= */

.proposal-section {
  margin-bottom: 14px;
  padding: 10px;

  border: 1px solid #e2e8f0;
  border-radius: 6px;

  background: #fff;
}

.proposal-section h3 {
  margin: 0 0 9px;
  padding-bottom: 6px;

  border-bottom: 1px solid #e5e7eb;

  color: #374151;
  font-size: 0.85rem;
}

.proposal-section h3::before {
  content: "";

  display: inline-block;

  width: 4px;
  height: 13px;

  margin-right: 6px;

  vertical-align: -2px;

  background: #3b82f6;
  border-radius: 2px;
}


/* =========================================================
   매장 정보
========================================================= */

.store-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.store-info label {
  display: flex;
  align-items: center;
  gap: 4px;

  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.store-info input,
.team-select {
  height: 28px;

  padding: 3px 7px;

  border: 1px solid #d1d5db;
  border-radius: 4px;

  background: #f9fafb;

  font-size: 12px;
  box-sizing: border-box;
  outline: none;
}

.team-select {
  width: 200px;
}

.store-info input:focus,
.team-select:focus {
  border-color: #60a5fa;
  background: #fff;
}


/* =========================================================
   청약 수량 테이블
========================================================= */

.bid-dt-table {
  width: 100%;
  margin: 8px 0 0;

  border-collapse: collapse;

  font-size: 0.75rem;
  table-layout: fixed;
}

.bid-dt-table th,
.bid-dt-table td {
  height: 27px;

  padding: 3px 2px;

  border: 1px solid #dfe3e8;

  text-align: center;
  vertical-align: middle;

  box-sizing: border-box;
}

.bid-dt-table th {
  background: #f3f4f6;
  color: #4b5563;
  font-weight: 700;
}

.bid-dt-table td {
  background: #fff;
}

.bid-dt-table tr:nth-child(2) td {
  background: #f8fafc;
}

.bid-dt-table input {
  width: 100%;
  height: 24px;

  padding: 2px;

  border: 0;
  outline: none;

  background: transparent;

  text-align: center;
  font-size: 0.75rem;
  box-sizing: border-box;
}

.bid-dt-table input[readonly] {
  color: #475569;
}


/* =========================================================
   차이값 강조
========================================================= */

.bid-dt-table tr:last-child td input {
  font-weight: 700;
}


/* =========================================================
   서명
========================================================= */

.signature-box {
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 10px;
}

.signature-box img,
.signature-box canvas {
  border: 1px solid #d1d5db;
  border-radius: 4px;
}


/* =========================================================
   날짜 / 신청자 정보
========================================================= */

.bid-dt-container > div > div {
  box-sizing: border-box;
}

.bid-dt-container input[type="date"] {
  height: 28px;

  padding: 3px 6px;

  border: 1px solid #d1d5db;
  border-radius: 4px;

  font-family: inherit;
  font-size: 12px;
}


/* =========================================================
   AG Grid
========================================================= */

:deep(.ag-br-balham) {
  --ag-cell-horizontal-padding: 3px;
  --ag-cell-vertical-padding: 1px;

  border: 1px solid #dfe3e8;
  border-radius: 5px;
  overflow: hidden;
}

:deep(.ag-br-balham .ag-header-cell) {
  background-color: #f3f4f6 !important;
  border-right: 1px solid #e5e7eb;
}

:deep(.ag-br-balham .ag-header-cell-text) {
  color: #374151;
  font-size: 0.72rem;
  font-weight: 700;
}

:deep(.ag-br-balham .ag-header-cell-label) {
  justify-content: center !important;

  white-space: pre-line;
  text-align: center;
}

:deep(.ag-br-balham .ag-cell) {
  color: #4b5563;
  font-size: 0.76rem;
  text-align: right;
}

:deep(.ag-br-balham .ag-row:hover) {
  background-color: #f8fafc !important;
}

:deep(.ag-br-balham .ag-cell.ag-column-first.year-cell) {
  width: 20px;

  padding-right: 5px;

  border-bottom: 1px solid #c0c0c0;

  font-size: 0.85rem;
  font-weight: 700;

  writing-mode: vertical-rl;
  text-orientation: upright;
}


/* =========================================================
   팝업
========================================================= */

.popup-overlay {
  position: fixed;
  inset: 0;

  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
}

.popup-container {
  width: 500px;
  max-width: calc(100vw - 30px);

  padding: 20px;

  background: #fff;

  border: 1px solid #e2e8f0;
  border-radius: 9px;

  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.18);

  box-sizing: border-box;
}

.popup-container h3 {
  margin: 0 0 15px;

  color: #1f2937;
  font-size: 1.05rem;
}


/* =========================================================
   팝업 테이블
========================================================= */

.popup-table {
  width: 100%;

  border-collapse: collapse;
}

.popup-table th,
.popup-table td {
  padding: 8px;

  border: 1px solid #e2e8f0;
}

.popup-table th {
  width: 95px;

  background: #f8fafc;

  color: #64748b;

  text-align: center;
  font-size: 12px;
  font-weight: 700;
}

.popup-table td {
  background: #fff;
}

.popup-table input,
.popup-table select {
  width: 100%;
  height: 31px;

  padding: 5px 8px;

  border: 1px solid #d1d5db;
  border-radius: 4px;

  background: #fff;

  font-family: inherit;
  font-size: 12px;

  box-sizing: border-box;
  outline: none;
}

.popup-table input:focus,
.popup-table select:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.08);
}


/* =========================================================
   팝업 버튼
========================================================= */

.popup-footer {
  margin-top: 15px;

  display: flex;
  justify-content: center;
  gap: 6px;
}

.popup-footer .btn-submit,
.popup-footer .btn-close {
  margin: 0;
}


/* =========================================================
   기타
========================================================= */

.no-announcement {
  padding: 25px 0;

  color: #9ca3af;

  text-align: center;
  font-size: 12px;
}


/* =========================================================
   스크롤바
========================================================= */

.announcement-body::-webkit-scrollbar,
.etc-cell::-webkit-scrollbar {
  width: 6px;
}

.announcement-body::-webkit-scrollbar-track,
.etc-cell::-webkit-scrollbar-track {
  background: #f8fafc;
}

.announcement-body::-webkit-scrollbar-thumb,
.etc-cell::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.announcement-body::-webkit-scrollbar-thumb:hover,
.etc-cell::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}


/* =========================================================
   모바일 / 좁은 화면
========================================================= */

@media (max-width: 900px) {

  .form-content,
  .list-form-content {
    flex-direction: column;
  }

  .form-left,
  .form-right,
  .form-left-details,
  .form-right-details {
    width: 100%;
    flex: none;
  }

  .announcement-body-table th,
  .announcement-body-table td {
    font-size: 11px;
    padding: 3px;
  }

  .btn-add {
    padding: 0 6px;
  }
}

</style>
-->